import logo from "./logo.svg";
import "./App.css";
import ViewPaymentLinkDetails from "./Views/ViewPaymentLinkDetails";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
// import InvoiceRefComponent from "./Invoice/InvoiceRefComponent";

const router = createBrowserRouter([
  {
    path: "/:linkref",
    element: <ViewPaymentLinkDetails />
  },
  {
    path: "/invoice/:invoice?/:paymentlink?",
    element: <ViewPaymentLinkDetails />
  },
  {
    path: "*",
    element: <h1 style={{ textAlign: "center", display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>Welcome to Linkqpay payment services &nbsp; <a href="https://merchant.linkqpay.com">login</a></h1>
  }
]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
